import validate from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-user-authentication": () => import("/home/nuxt-front-end-V2/nuxt-front-end/middleware/checkUserAuthentication.js")
}